// common
export const POST_REQUEST = 'exportConsultations/POST_REQUEST'
export const POST_SUCCESS = 'exportConsultations/POST_SUCCESS'
export const POST_FAILURE = 'exportConsultations/POST_FAILURE'
export const GET_REQUEST = 'exportConsultations/GET_REQUEST'
export const GET_SUCCESS = 'exportConsultations/GET_SUCCESS'
export const GET_FAILURE = 'exportConsultations/GET_FAILURE'
// cases
export const UPDATE_CASE_LIST = 'exportConsultations/UPDATE_CASE_LIST'
export const UPDATE_CASE_RELATE_LIST = 'exportConsultations/UPDATE_CASE_RELATE_LIST'